/**
 * Shared ATTOM foreclosure case lookup (Athena-backed).
 */

import { client } from "@/hera-api/client/client.gen";

export interface AttomForeclosureCaseDetailsResponse {
  case_number: string;
  case: Record<string, string | number | null> | null;
  documents: Array<Record<string, string | number | null>>;
}

export async function getAttomForeclosureCaseDetails(
  caseNumber: string,
  jurisdictionFips?: string | null,
): Promise<AttomForeclosureCaseDetailsResponse> {
  const result = await client.get<AttomForeclosureCaseDetailsResponse>({
    url: "/shared/attom/foreclosure-case-details",
    query: {
      case_number: caseNumber,
      ...(jurisdictionFips ? { jurisdiction_fips: jurisdictionFips } : {}),
    },
    parseAs: "json",
    security: [{ scheme: "bearer", type: "http" }],
  });

  if (result.error) {
    const err = result.error as { detail?: string; message?: string };
    throw new Error(
      err.detail ??
        err.message ??
        "Failed to load ATTOM foreclosure case details",
    );
  }

  return result.data as AttomForeclosureCaseDetailsResponse;
}
